import InputDoubleRange from './InputDoubleRange';

export default InputDoubleRange;
